import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { BIDS_API } from '../bidsAPIClient';
import { IExportBidsQueryOptions } from '../types';

/**
 * React Query hook for exporting bids data to Excel.
 */
export const EXPORT_BIDS_MUTATION_KEY = 'export-bids-mutation-key';

interface IExportBidsMutationProps {
  /**
   * Callback to be called when the export fails
   */
  onErrorCallback: (err: IApiError) => void;
  /**
   * Callback to be called when the export is successful
   */
  onSuccessCallback: (fileData: BlobPart) => void;
}

/**
 * React Query mutation hook for exporting bids data to Excel.
 */
export const useExportBidsMutation = ({
  onErrorCallback,
  onSuccessCallback,
}: IExportBidsMutationProps) => {
  const { error, isError, isPending, mutate } = useMutation({
    mutationFn: (queryParams?: IExportBidsQueryOptions) =>
      BIDS_API.exportBidsExcel(queryParams),
    mutationKey: [EXPORT_BIDS_MUTATION_KEY],
    networkMode: 'always', // Even make calls when offline
    onError: onErrorCallback,
    onSuccess: onSuccessCallback,
  });

  return {
    error,
    isError,
    isPending,
    mutate,
  };
};
